<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="reload"
      @submitDel="submitDel"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @batchDel="batchDel"
        @query="getData"
        :disabled="disabled"
        @openEditFormDialog="openEditFormDialog"
      />
    </page-main>
    <EditFormDialog
      ref="editFormDialog"
      :visible.sync="editFormDialogParams.visible"
      :title="editFormDialogParams.title"
      :changeOrderCode="changeOrderCode"
      :disabled="editFormDialogParams.disabled"
      :code="editFormDialogParams.code"
      :isCopy="editFormDialogParams.isCopy"
      @reload="reload"
      @close="close"
    />
  </div>
</template>
<script>
import EditFormDialog from '../edit-form/dialog.vue'
import BaseTable from '@/mixins/base-table'
import PageMain from './main.vue'
import PageHeader from './header.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditFormDialog },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      usePage: true,
      editFormDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  methods: {
    close() {
      this.editFormDialogParams.visible = false
    },
    getData(form) {
      this.page.pageSize = 1000 //设置查询最大条数为1000
      this.loading = true
      this.$api
        .changeOrdeDemandPackageListApi({
          changeOrderCode: this.changeOrderCode,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        add: this.$l('INDEX.tips_add_packaging_info') || '添加订单包装需求信息',
        edit:
          this.$l('INDEX.tips_modify_packaging_info') || '修改订单包装需求信息',
        detail:
          this.$l('INDEX.tips_view_packaging_info') ||
          '查看修改订单包装需求信息',
        copy:
          this.$l('INDEX.tips_copy_packaging_info') || '复制订单包装需求信息',
      }
      this.editFormDialogParams = {
        visible: true,
        title: types[type],
        code: params.code,
        disabled: type === 'detail',
        isCopy: type === 'copy',
      }
    },
    cancel() {
      this.$refs.editForm.cancel()
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api
            .changeOrdeDemandPackageBatchDelApi({
              listCode: listCode,
              changeOrderCode: this.changeOrderCode,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.$refs.header.query()
            })
        })
        .catch(() => {})
    },
  },
}
</script>
